import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import type { IUserInfoResponseData, IWalletBalanceInfo, IUserSubscriptionInfo } from '@/apis/trade/typings';

interface IAssetState {
    userSubscriptionInfo: IUserSubscriptionInfo | null;
    walletBalanceInfo: IWalletBalanceInfo | null;
    isVip: boolean;
    /**
     * 全局"支付成功"信号：每次任意支付链路 confirm 成功都更新为新时间戳。
     * 业务页通过 useEffect 依赖该值触发各自的刷新/解锁逻辑，
     * 让 PayPal checkout-url 回跳后的成功事件能跨业务组件传递。
     * 消费后须调用 clearPaymentSuccess，避免卸载后再次进入页面误触发。
     */
    lastPaymentSuccessAt: number;
}

interface IAssetActions {
    setAssetInfo: (data: IUserInfoResponseData) => void;
    clearAssetInfo: () => void;
    markPaymentSuccess: () => void;
    clearPaymentSuccess: () => void;
}

const initialState: IAssetState = {
    userSubscriptionInfo: null,
    walletBalanceInfo: null,
    isVip: false,
    lastPaymentSuccessAt: 0,
};

export const useAssetStore = create<IAssetState & IAssetActions>()(
    immer(set => ({
        ...initialState,

        setAssetInfo: (data: IUserInfoResponseData) =>
            set({
                userSubscriptionInfo: data.user_subscription_info,
                walletBalanceInfo: data.wallet_balance_info,
                isVip: data.is_vip,
            }),

        clearAssetInfo: () =>
            set({
                userSubscriptionInfo: null,
                walletBalanceInfo: null,
                isVip: false,
            }),

        markPaymentSuccess: () => set({ lastPaymentSuccessAt: Date.now() }),
        clearPaymentSuccess: () => set({ lastPaymentSuccessAt: 0 }),
    }))
);
